<template lang="html">
  <div
    class="cw-favorite-button has-text-centered"
    @click="$emit('update:selected', !selected)"
    :class="{ 'has-text-primary': selected, 'has-text-grey-medium': !selected }"
  >
    <span class="icon is-left is-medium">
      <icon
        v-if="selected"
        name="starFilled"
        scale="2"
        class="has-text-primary"
      ></icon>
      <icon
        v-else
        name="starOutline"
        scale="2"
        class="has-text-gray-medium"
      ></icon>
    </span>
    <div class="no-text-selection">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'cw-favorite-button',
  // share common functionality with component mixins
  mixins: [],
  props: {
    title: {
      type: String,
      default: 'Favorite',
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  // variables
  data() {
    return {};
  },
  computed: {},
  components: {},
  // methods
  watch: {},
  methods: {},
};
</script>

<style lang="stylus" scoped>


.cw-favorite-button {
  cursor: pointer;
}
</style>
